export default "__VITE_ASSET__DPcyRC39__"